import { EventStatus } from '../event.types';
import { Moment } from 'moment';

export class EventNote {
	noteId: number;
	eventStatus?: EventStatus;
	type?: EventNoteType;
	comment: string;
	addedBy: string;
	actionOn?: string | Moment;
	createdOn: string | Moment;
}

export interface NewUpdatedEventNote {
	comment: string;
	type?: EventNoteType;
	actionOn?: string | Moment;
}

export enum EventNoteType {
	Quote = 1,
	Payment = 2,
	Chase1 = 100,
	Chase2 = 101,
	Chase3 = 102,
	BookAccomodation = 40,
}
